import type { SpreadsheetColumnId } from '~/_shared/types/spreadsheetData/spreadsheetColumn';

export enum MapPresentationalView {
  Loading = 'Loading',
  Regular = 'Regular',
  Password = 'Password',
  PrivateTokenMissing = 'PrivateTokenMissing',
}

export type MapPresentationalState = {
  isPresentationalMenuShown: boolean;
  showWrongPasswordError: boolean;
  view: MapPresentationalView;
  availableGroupingColumns: SpreadsheetColumnId[]; // On presentational maps the user should be able to choose grouping only from these columns
};
